module.exports = __webpack_public_path__ + "assets/read-aloud-active.cf70b66f.svg";